import { render, staticRenderFns } from "./add-product-serial-manual.vue?vue&type=template&id=4dc87ed7&scoped=true&"
import script from "./add-product-serial-manual.vue?vue&type=script&lang=js&"
export * from "./add-product-serial-manual.vue?vue&type=script&lang=js&"
import style0 from "./add-product-serial-manual.vue?vue&type=style&index=0&id=4dc87ed7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc87ed7",
  null
  
)

export default component.exports